import { useCallback, useSyncExternalStore } from 'react';

const emptySubscribe = () => () => {};

const getServerSnapshot = () => false;

export const useWebShare = shareData => {
  const getClientSnapshot = useCallback(() => {
    if (!shareData || typeof navigator === 'undefined' || !navigator.share) {
      return false;
    }
    return navigator.canShare ? navigator.canShare(shareData) : true;
  }, [shareData]);

  const isSupported = useSyncExternalStore(emptySubscribe, getClientSnapshot, getServerSnapshot);

  const share = useCallback(
    async ({ onSuccess, onError } = {}) => {
      if (!isSupported) return;
      try {
        await navigator.share(shareData);
        if (onSuccess) onSuccess();
      } catch (error) {
        if (error.name !== 'AbortError') {
          if (onError) onError(error);
        }
      }
    },
    [isSupported, shareData]
  );

  return { isSupported, share };
};
